module.exports = __webpack_public_path__ + "static/media/igotyourback.5b147125.jpg";